<!-- We do not want to display the breadcrumb component until story and style is finalized -->

<div class="container-fluid" role="navigation">
  <ol class="breadcrumb-list mat-typography">
    <li
      *ngFor="let segment of segments; last as isLast"
      class="breadcrumb-list-item"
      [ngClass]="{ active: isLast }"
    >
      <a
        *ngIf="!isLast && segment.routerLink"
        [routerLink]="[segment.routerLink]"
        routerLinkActive="router-link-active"
      >
        {{ segment.text }}
      </a>
      <span *ngIf="isLast || !segment.routerLink">{{ segment.text }}</span>
    </li>
  </ol>
</div>
